<template>
  <div class="home">
    Administration Panel HomePage
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>
